import { isServerside } from '../../core/utils/isServerside';
import getUrlParameters from '../../utils/getUrlParameters';

export const getArticleId = (): string | undefined => {
  const { article_id: articleId } = getUrlParameters();
  if (articleId) {
    return articleId;
  }

  if (!isServerside() && window.dfp_config?.article_id) {
    return window.dfp_config.article_id;
  }

  if (!isServerside() && window.ipcTags?.contentId) {
    return window.ipcTags.contentId;
  }
  return undefined;
};
